document.addEventListener('DOMContentLoaded', function() {
    const registry = customElements.get('quantity-input');
    if (!registry) return;
    
    const proto = registry.prototype;
    const oldValidate = proto.validateQtyRules;
    
    // Override the validation rules
    proto.validateQtyRules = function() {
        
        // ONLY apply this inside the Cart or Cart Drawer (as requested)
        if (this.closest('cart-items, cart-drawer, .cart-item, #CartDrawer')) {
            // Shopify checks BOTH 'min' and 'data-min' to show that error message.
            // By changing both to "0", Shopify natively enables the minus button 
            // and natively deletes the item when it reaches 0, with ZERO errors!
            this.input.min = "0";
            this.input.dataset.min = "0";
        }
        
        // Run the original Shopify validation with our new 0 limits
        if (oldValidate) oldValidate.call(this);
    };
    
    // Apply immediately on page load
    document.querySelectorAll('quantity-input').forEach(i => i.validateQtyRules && i.validateQtyRules());
});